<template>
  <div class="hab-detail-evaluate">
    <div
        v-if="isLoading"
        class="text-center"
    >
      <compLoading />
    </div>
    <div v-if="!isLoading && get(dataReview, 'items', []).length === 0" class="not-data">
      Not Data
    </div>
    <div v-if="!isLoading">
      <div v-if="get(dataRating, 'overall.count', 0)">
        <CompFlex
          align="center"
          wrap="wrap"
          gap="15"
          className="hab-detail-star"
        >
          <span class="highligh">{{ get(dataRating, 'overall.rv_main_value', 0) }}</span>
          <CompStarRating
            :value="Number(Math.ceil(get(dataRating, 'overall.rv_main_value', 0)))"
            :disabled="true"
            :starSize="18"
          />
          <span
            >{{ get(dataRating, 'overall.count', 0) }} {{ $t("detail.danh_gia") }}</span
          >
        </CompFlex>
        <CompFlex
          v-if="get(dataRating, 'rating', []).length !== 0"
          align="center"
          wrap="wrap"
          gap="15"
          className="hab-detail-rating-range"
        >
          <div v-for="(item, index) in dataRating.rating" :key="index">
            <span>{{
              locale === "en" ? item.label_english : item.label
            }}</span>
            <CompFlex align="center" gap="10">
              <div style="flex-grow: 1; width: 100%">
                <CompRange
                  :max="5"
                  :value="[0, get(item, 'rv_main_value', 0)]"
                  :step="0.1"
                  :height="6"
                  :dotSize="0"
                  tooltip="none"
                  :disabled="true"
                />
              </div>
              <div style="white-space: nowrap">{{ item.rv_main_value }}</div>
            </CompFlex>
          </div>
        </CompFlex>
      </div>
      <perfect-scrollbar
        v-if="get(dataReview, 'items', []).length !== 0"
        ref="scrollbar"
        tag="div"
        :watchOptions="false"
        class="scroll-evaluate mt-20"
      >
        <div
          v-for="(item, index) in dataReview.items"
          :key="index"
          class="evaluate-list"
        >
          <CompFlex align="center" gap="10">
            <div
              :class="[
                'evaluate-list__avatar',
                {
                  [renderBg()]: renderBg(),
                },
              ]"
            >
              {{ renderAvatar(item.name) }}
            </div>
            <div>
              <p>{{ item.name || "" }}</p>
              <CompStarRating
                :value="item.rating ? Number(item.rating) : 0"
                :disabled="true"
                :starSize="12"
              />
            </div>
          </CompFlex>
          <div v-if="get(item, 'comment', '')" v-html="get(item, 'comment', '')" class="mt-16"></div>
          <p class="text-12-400 mt-16 mb-0" style="color: #b8b8b8">
            {{ $t("detail.dang_ngay") }} {{ renderDate(item.created_at) }}
          </p>
        </div>
        <compLoading v-if="isLoadingMore" />
        <div
          v-if="get(dataReview, 'items', []).length < get(dataReview, 'total', 0)"
          class="main-layout-home__pagination"
        >
          <span @click="onLoadMoreReview">{{ $t("common.load_more") }}</span>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>
<script>
import compLoading from "../../../loading/index";
import CompRange from "../../../range/index.vue";
import CompFlex from "../../../flex/index.vue";
import CompStarRating from "../../../star-rating/index.vue";
import { isEmpty, get } from "lodash";

export default {
  components: {
    compLoading,
    CompFlex,
    CompStarRating,
    CompRange,
  },
  props: {
    operatorId: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    renderBg: (state) => () => {
      const random = Math.floor(Math.random() * state?.bg?.length);
      return state?.bg?.[random];
    },
    renderDate: () => (date) => {
      return moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "";
    },
    renderAvatar: () => (name) => {
      const nameArr = name ? name.split(" ") : [];
      if (nameArr?.length === 1) {
        return Array.from(nameArr[0])[0];
      } else if (nameArr?.length >= 2) {
        const firstText = Array.from(nameArr[nameArr?.length - 2])[0];
        const lastText = Array.from(nameArr[nameArr?.length - 1])[0];
        return `${firstText}${lastText}`;
      }

      return "A";
    },
  },
  data() {
    return {
      bg: ["green-v1", "green-v2", "pink", "orange", "yellow"],
      locale: locale,
      isLoading: true,
      isLoadingMore: false,
      dataReview: null,
      dataRating: null,
    };
  },
  methods: {
    get,
    isEmpty,
    callReviews(page = 1) {
      if (page > 1) {
        this.isLoadingMore = true;
      }

      const params = {
        id: this.operatorId,
        page: page,
        per_page: 10,
        // rating: {
        //   max: 2,
        // },
      };
      this.$store.dispatch("getReviews", params).then((result) => {
        if (result?.page === 1) {
          this.dataReview = result;
        } else {
          this.dataReview = {
            ...this.dataReview,
            items: [...this.dataReview?.items, ...result?.items],
          };
        }
        this.isLoading = false;
        this.isLoadingMore = false;
      }).catch(() => {
        this.isLoading = false;
      });

      return true;
    },
    callRating() {
      this.isLoading = true;
      this.$store
        .dispatch("getRating", { id: this.operatorId })
        .then((result) => {
          this.dataRating = result || null;

          this.callReviews(1)
        }).catch(() => {
        this.isLoading = false;
      });

      return true;
    },
    onLoadMoreReview() {
      this.callReviews(this.dataReview?.page + 1);
    },
  },
  mounted() {
    this.callRating();
  },
};
</script>

<style lang="scss" scoped>
.scroll-evaluate {
  max-height: 500px;
}
</style>
